// Global alerts plugin for Vue using existing BootstrapVue Toast
export default {
  install(Vue) {
    // Mixin for global alert methods using $bvToast
    Vue.mixin({
      methods: {
        // Success alert
        $showSuccess(message, options = {}) {
          this.$bvToast.toast(message, {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-right',
            ...options
          });
        },
        
        // Error alert
        $showError(message, options = {}) {
          this.$bvToast.toast(message, {
            title: 'Erro',
            variant: 'danger',
            solid: true,
            autoHideDelay: 8000,
            toaster: 'b-toaster-top-right',
            ...options
          });
        },
        
        // Warning alert
        $showWarning(message, options = {}) {
          this.$bvToast.toast(message, {
            title: 'Aviso',
            variant: 'warning',
            solid: true,
            autoHideDelay: 6000,
            toaster: 'b-toaster-top-right',
            ...options
          });
        },
        
        // Info alert
        $showInfo(message, options = {}) {
          this.$bvToast.toast(message, {
            title: 'Informação',
            variant: 'info',
            solid: true,
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-right',
            ...options
          });
        },
        
        // Generic alert method
        $showAlert(variant, message, title = '', options = {}) {
          this.$bvToast.toast(message, {
            title: title || this.getDefaultTitle(variant),
            variant: variant,
            solid: true,
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-right',
            ...options
          });
        },
        
        // Clear all alerts
        $clearAlerts() {
          this.$bvToast.hide();
        },
        
        // Helper to get default titles
        getDefaultTitle(variant) {
          const titles = {
            success: 'Sucesso',
            danger: 'Erro',
            warning: 'Aviso',
            info: 'Informação',
            primary: 'Notificação',
            secondary: 'Notificação'
          };
          return titles[variant] || 'Notificação';
        },
        
        // Helper methods for common error scenarios
        $handleApiError(error) {
          let message = 'Ocorreu um erro inesperado';
          
          // Check if error exists and has response
          if (error && error.response) {
            if (error.response.data?.detail) {
              message = error.response.data.detail;
            } else if (error.response.data?.message) {
              message = error.response.data.message;
            } else if (error.response.statusText) {
              message = error.response.statusText;
            }
            
            // Handle specific status codes
            switch (error.response.status) {
              case 400:
                message = error.response.data?.detail || 'Dados inválidos enviados';
                break;
              case 401:
                message = 'Não autorizado. Faça login novamente.';
                break;
              case 403:
                message = 'Acesso negado. Você não tem permissão para esta ação.';
                break;
              case 404:
                message = 'Recurso não encontrado';
                break;
              case 422:
                message = error.response.data?.detail || 'Dados de entrada inválidos';
                break;
              case 500:
                message = 'Erro interno do servidor';
                break;
              case 502:
                message = 'Servidor indisponível';
                break;
              case 503:
                message = 'Serviço temporariamente indisponível';
                break;
            }
          } else if (error && error.message) {
            message = error.message;
          } else if (typeof error === 'string') {
            message = error;
          }
          
          this.$showError(message);
        },
        
        // Helper for validation errors
        $handleValidationErrors(errors) {
          if (Array.isArray(errors)) {
            errors.forEach(error => this.$showError(error));
          } else if (typeof errors === 'object') {
            Object.keys(errors).forEach(field => {
              const fieldErrors = errors[field];
              if (Array.isArray(fieldErrors)) {
                fieldErrors.forEach(error => {
                  this.$showError(`${field}: ${error}`);
                });
              } else {
                this.$showError(`${field}: ${fieldErrors}`);
              }
            });
          } else {
            this.$showError(errors);
          }
        }
      }
    });
  }
};
